import React, { SVGAttributes } from 'react'

const ChevronRight: React.FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='35' height='34' viewBox='0 0 35 34' fill='none'>
      <g clipPath='url(#clip0_5135_43)'>
        <path
          d='M15.0201 8.50037L13.0226 10.4979L19.5109 17.0004L13.0226 23.5029L15.0201 25.5004L23.5201 17.0004L15.0201 8.50037Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_5135_43'>
          <rect width='34' height='34' fill='white' transform='translate(0.853394)' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChevronRight
